module.exports = __webpack_public_path__ + "img/logo.d7088d36.jpeg";